<template>
  <div>
    <div class="footer1">
      <div class="n-footer">
        <div class="boxwrapper w970 flex j-between">
          <div class="box1 box">
            <h2>常见问题</h2>
            <p>
              <a
                href="https://fangzhen.autotool.com.cn/JavaEE/files/融畅易和科技数字商城购买流程.html"
                target="_blank"
              >购买流程</a>
            </p>
            <p>
              <a
                href="https://fangzhen.autotool.com.cn/JavaEE/files/融畅易和科技数字商城支付方式.html"
                target="_blank"
              >支付方式</a>
            </p>
            <p>
              <a
                href="https://fangzhen.autotool.com.cn/JavaEE/files/融畅易和科技数字商城发票制度.html"
                target="_blank"
              >发票制度</a>
            </p>
          </div>
          <div class="box2 box">
            <h2>关于我们</h2>
            <p @click="gogo" class="box-us">
              关于我们
              <!-- <a
                href="https://fangzhen.autotool.com.cn/JavaEE/files/融畅易和科技数字商城关于我们.html"
                target="_blank"
              ></a> -->
            </p>
            <p @click="gogogo" class="box-us">
              联系我们
              <!-- <a
                href="https://fangzhen.autotool.com.cn/JavaEE/files/融畅易和科技数字商城联系我们.html"
                target="_blank"
              ></a> -->
            </p>
          </div>
          <div class="box3 box">
            <h2>隐私版权</h2>
            <p>
              <a
                href="https://fangzhen.autotool.com.cn/JavaEE/files/融畅易和科技数字商城隐私政策.html"
                target="_blank"
              >隐私政策</a>
            </p>
            <p>
              <a
                href="https://fangzhen.autotool.com.cn/JavaEE/files/融畅易和科技数字商城版权声明.html"
                target="_blank"
              >版权声明</a>
            </p>
          </div>
          <div class="box4 box">
            <h2>在线客服</h2>
            <p>
              <img src="@/assets/images/icon-phone.png">
              <a href="javascript:;">028-85243789</a>
            </p>
            <p>
              <a href="javascript:;" class="n-time">周一至周五 9:00 — 18:00</a>
            </p>
            <p>
              <img src="@/assets/images/icon-qq.png">
              <a target="_top" href="tencent://message/?uin=2165832720&Menu=yes">在线QQ客服</a>
            </p>
            <p>
              <a href="javascript:;" class="n-time">周一至周五 9:00 — 18:00</a>
            </p>
          </div>
        </div>
      </div>
      <div class="n-isp">
        <p style="line-height:30px">Copyright&copy; 2015-<i id="year" style="vertical-align: baseline;"></i></p>
        <div style="height:20px">
          <!-- 成都融畅易和科技有限公司  -->
          成都融畅易和科技有限公司 版权所有
          <a href=https://beian.miit.gov.cn/ target=_blank>
           {{domainName}}
          </a>
          <div style="width:300px;margin:0 auto;padding-top:5px" v-if="aaa==0">
		 		<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51011202000601" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="../assets/images/police.png" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#f9f9f9;">川公网安备 51011202000601号</p></a>
		 	</div>
      <div style="width:300px;margin:0 auto; padding-top:5px;" v-else-if="aaa==1">
		 		<a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51011202000604" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="../assets/images/police.png" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#f9f9f9;">川公网安备 51011202000604号</p></a>
		 	</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      domainName: "蜀ICP备2022011810号",
      aaa: 0,
    };
  },
  components: {},
  props: {},
  methods: {
    gogogo() {
      this.$router.push({
        path: "/contact",
      });
    },
    gogo() {
      this.$router.push({
        path: "/about",
      });
    },
  },
  mounted() {
    let url = window.location.href;
    if (url.indexOf("cdrcyh") != -1) {
      this.aaa = 1;
      this.domainName = "蜀ICP备2022011810号";
    } else {
      this.domainName = "蜀ICP备2022011810号";
    }
  },
  created() {
    this.$nextTick(() => {
      var now = new Date();
      var year = now.getFullYear(); //获取当前年份
      document.getElementById("year").innerText = year;
    });
  },
  watch: {},
  computed: {},
};
</script>

<style scoped lang='scss'>
.footer1 {
  font-size: 16px;
}
.n-footer {
  height: 280px;
  background-color: rgb(38, 38, 38);
  padding-top: 65px;
  box-sizing: border-box;
}

.w970 {
  width: 1200px;
  margin: 0 auto;
}

.n-footer .box {
  flex: 1;
}

.n-footer .box h2 {
  height: 18px;
  font-size: 18px;
  line-height: 23px;
  color: #f9f9f9;
  font-weight: normal;
  margin-bottom: 31px;
}

.n-footer .box p a {
  height: 14px;
  font-size: 14px;
  line-height: 30px;
  color: #c0c0c0;
  cursor: pointer;
  margin-bottom: 14px;
}
.box-us {
  height: 14px;
  font-size: 14px;
  line-height: 30px;
  color: #c0c0c0;
  cursor: pointer;
  margin-bottom: 14px;
}
.n-footer i,
.n-footer span,
.n-footer a {
  font-weight: normal;
  font-style: normal;
  vertical-align: middle;
  text-decoration: none;
}

.n-footer .box4 {
  margin-right: 0px;
}

.n-footer .box4 p img {
  vertical-align: middle;
  opacity: 1;
  margin-right: 5px;
  width: 32px;
  height: 32px;
}

.n-footer .box4 p .n-time {
  font-size: 12px;
  color: #bbbbbb;
  margin-left: 40px;
}

.n-isp {
  height: 83px;
  background-color: #2f2f2f;
  text-align: center;
  // line-height: 63px;
  font-size: 14px;
  color: #f9f9f9;
}
.n-isp a {
  color: #f9f9f9;
}
</style>